module.exports = "/public/webpack/img/statusbe1cede97289c13920048f238fd37b85.gif";